import * as React from "react";
import { useState, useEffect, useContext } from "react";
import {
  reduxForm,
  getFormValues,
  Field,
  change,
  InjectedFormProps,
  reset,
} from "redux-form";
import { connect } from "react-redux";
import { Row, Col, Container, Card, CardTitle, CardBody } from "reactstrap";
import { Button } from "reactstrap";
import SpinnerModel from "../../../../commonfields/SpinnerModel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  transformDateWithDash,
  transformDateWithoutTime,
} from "../../../../utils/dateUtil";
import { faImages } from "@fortawesome/free-solid-svg-icons";
import TextField from "../../../../commonfields/TextField";
import EmailTextField from "../../../../commonfields/EmailTextField";
// import { PhoneNumberField } from "common-fields";
import PhoneNumberField from "../../../../commonfields/PhoneNumberfield";
import SelectField from "../../../../commonfields/SelectField";
import normaliseZipcode from "../../../../utils/normaliseZipCode";
import { State, Suggestion, suggestions } from "../LeadDetails";
import FutureDatePicker from "../../../../commonfields/FutureDatePicker";
import PastDatePicker from "../../../../commonfields/PastDatePicker";
import PhotoUploader from "../../../../commonfields/PhotoUploader";
import NormaliseExt from "../../../../utils/NormaliseExt";
import SelectButtonField2 from "../../../../commonfields/SelectButtonField2";
import { percentages } from "../../../../data/staticOptions";
import validate from "./Validate";
import warn from "./FieldErrors";
import EmailCheckButton from "../../../../commonfields/EmailCheckButton";
import PhoneCheckButton from "../../../../commonfields/PhoneCheckButton";
import Service from "../../../../services";
import { AxiosError, AxiosResponse } from "axios";
import normaliseDollar from "../../../../utils/normaliseDollar";
import { toast } from "react-toastify";
import { BankUserContext } from "../../../../bankUserContext";
import ValidateSelectField from "../../../../commonfields/ValidateSelectField";
import { useParams } from "react-router-dom";
import {
  catchErrorGeneric,
  dollarSymbol,
  sendPhondNumberFormat,
} from "../../../../utils/GeneralUtils";
import { catchError } from "../../../../utils/Utils";
import { TriggerContext } from "../../../../Context/TriggerContext";
import NormalizeSpace from "../../../../utils/NormalizeSpace";

interface options {
  id: string;
  text: string;
  value: string;
}

export interface ICreateLeadFormProps { }

const CreateLeadForm: React.FC<
  ICreateLeadFormProps &
  InjectedFormProps<Record<string, unknown>, ICreateLeadFormProps>
> = (props: any, ref: any) => {
  const [loader, setLoader] = useState<boolean>(false);
  const [checkEmail, setEmailCheck] = useState(false);
  const [businessSuggestionsData, setBusinessSuggestions] = useState<any>();
  const [contactSuggestionsData, setContactSuggestions] = useState<any>();
  const [contactSuggestionsBox, setContactSuggestionsBox] =
    useState<boolean>(false);
  const [businessSuggestionsBox, setBusinessSuggestionsBox] =
    useState<boolean>(false);
  const [states, setStates] = useState<State[]>([]);
  const [emailFields, setEmailFields] = useState<number>(1);
  const [phoneFields, setPhoneFields] = useState<number>(1);
  const [selectedEmailButtons, setEmailSelectedButtons] = useState<boolean[]>([
    true,
  ]);
  const [selectedPhoneButtons, setPhoneSelectedButtons] = useState<boolean[]>([
    true,
  ]);
  const [sameLocationDisable, setSameLocationDisable] =
    useState<boolean>(false);
  const [disableContactAddress, setDisableContactAddress] = useState(true);
  const [disableBusinessAddress, setDisableBusinessAddress] = useState(true);
  const [autoBusinessInfo, setAutoBusinessInfo] = useState<any>({});
  const [businessInfoDisable, setBusinessInfoDisable] =
    useState<boolean>(false);
  const [autoBusinessClientId, setAutoBusinessClientId] = useState<string>("");
  const { clientId } = useParams();
  const [init, setInit] = useState(true);
  const service = new Service();
  const context = useContext(BankUserContext);
  const Trigger = useContext(TriggerContext);

  useEffect(() => {
    const selectProductInformation = {
      ...props.formValues,
      productName: props?.formValues?.productName,
      account: props?.formValues?.account,
      estimatedValue: props?.formValues?.estimatedValue,
      expectedCloseDate: props?.formValues?.expectedClose,
      percentToSale: props?.formValues?.percentToSale,
      //
      businessName: props?.formValues?.businessName,
    };
    props?.selectProductInformation(selectProductInformation);
  }, [props?.formValues]);

  // useEffect(() => {
  //   if (!triggered) {
  //     handleAutoBusinessInfo(); // Trigger the function from parent on mount
  //     setTriggered(true);
  //   }
  // }, [props, triggered]); // Only trigger once
  // React.useImperativeHandle(ref, () => ({
  //   handleAutoBusinessInfo,
  // }));

  // useEffect(() => {
  //   console.log(props?.createLeadValues, "props?.createLeadValues?.clientId");
  //   if (props?.createLeadValues?.clientId) {
  //     console.log("first condition");

  //     if (init) {
  //       console.log("second condition");
  //       handleAutoBusinessInfo();
  //       setInit(false);
  //     }
  //   }
  // }, [props?.createleadValues]);

  const handleAutoBusinessInfo = () => {
    if (
      (props?.formValues?.businessName &&
        props?.formValues?.businessName.length > 0) ||
      (props?.createLeadValues?.businessName &&
        props?.createLeadValues?.businessName?.length > 0)
    ) {
      // let payload = {
      //   screen: "ProspectTR",
      //   sections: "getClientContactsbyOrgId",
      //   orgId: "a3fe60fe-3f6f-11ee-be56-0242ac120002",
      //   isJsonReturnObject: false,
      //   businessName:
      //     (props?.formValues?.businessName && props?.formValues?.businessName) ||
      //     "",
      //   // search,
      // };
      let payload = {
        screen: "CustomerDetails",
        sections: "GetBusinessInfo",
        orgId: context.bankuserDetails?.organization.orgId,
        clientId: props?.createLeadValues?.clientId || clientId,
        businessName:
          (props?.formValues?.businessName &&
            props?.formValues?.businessName) ||
          props?.createLeadValues?.businessName,
        isJsonReturnObject: false,
      };

      service
        .getLeadsData(payload)
        .then((res: any) => {
          const contactDetails = res?.data[0];

          if (res?.data && res?.data.length > 0) {
            setBusinessInfoDisable(true);
          } else {
            setBusinessInfoDisable(false);
          }
          const modifiedLead = {
            ...props?.formValues,
            businessName: contactDetails?.businessName,
            businessStreetAddress: contactDetails?.businessStreetAddress,
            businessUnitSuite: contactDetails?.businessUnitSuite,
            businessCity: contactDetails?.businessCity,
            businessState: contactDetails?.businessState,
            businessZipCode: contactDetails?.businessZipCode,
            currentFormValues: props?.createLeadValues || props?.formValues,
          };
          setAutoBusinessInfo(modifiedLead);
          props?.handleBusinessData(modifiedLead);
        })
        .catch((err: any) => {
          // toast.error("Something Went Wrong");
          catchErrorGeneric("Something went wrong");
        });
    } else {
      // props.dispatch(change("CreateLeadForm", "businessName", ""));
      // props.dispatch(change("CreateLeadForm", "businessStreetAddress", ""));
      // props.dispatch(change("CreateLeadForm", "businessUnitSuite", ""));
      // props.dispatch(change("CreateLeadForm", "businessCity", ""));
      // props.dispatch(change("CreateLeadForm", "businessState", ""));
      // props.dispatch(change("CreateLeadForm", "businessZipCode", ""));
    }
  };

  const getId = () => {
    if (props?.editLeadBtn || props?.createLeadValues?.genericTracker) {
      // to send parentClientId
      return props?.editLeadBtn || props?.createLeadValues?.genericTracker
        ? props?.createLeadValues?.parentClientId &&
        props?.createLeadValues?.parentClientId
        : undefined;
    } else if (!props?.isExistingCreateLead) {
      return !props?.isExistingCreateLead // to send parentClient Id
        ? props?.parentClientId
          ? props?.parentClientId
          : clientId
        : undefined;
    }
  };

  const handleDeletePhoto = () => {
    // console.log("deletePhoto", props?.formValues?.photo?.bucket);
    // if (props?.formValues?.photo) {
    // to call delete api only  if image is set through api not if uploaded from local
    // const data = {
    //   sections: "ClientActionDocument",
    //   data: {
    //     clientActionDocumentId: props?.createLeadValues?.profileDocId,
    //   },
    // };
    // service
    //   .deleteFile(props?.createLeadValues?.profileDocId, data)
    //   .then(() => {})
    //   .catch((error: AxiosError) => {
    //     catchError(error, true);
    //   })
    //   .finally(() => {
    //     // this.setState({ loader: false });
    //   });
    // }
  };

  const createLeadValidation = () => {
    if (props?.buttonName === "Create Lead") {
      const payload = {
        screen: "ProspectDetails",
        sections: "createLeadValidation",
        isJsonReturnObject: false,
        businessName: props?.formValues?.businessName
          ? props?.formValues?.businessName
          : null,
        accountName: props?.formValues?.account
          ? props?.formValues?.account
          : null,
        productName: props?.formValues?.productName
          ? props?.formValues?.productName
          : null,
      };

      service
        .createLeadValidation(payload)
        .then((response: any) => {
          if (response.data[0]?.isValid) {
            createLead();
          } else {
            toast.error("Business name already existed!");
          }
        })
        .catch((error: AxiosError) => {
          // toast.error("Something Went Wrong");
          catchErrorGeneric("Something went wrong");
        });
    } else if (props?.buttonName === "Save") {
      createLead();
    }
  };

  useEffect(() => {
    if (props?.createLeadValues?.businessName) {
      props.dispatch(
        change(
          "CreateLeadForm",
          "businessName",
          props?.createLeadValues?.businessName
        )
      );
    }
    if (props?.createLeadValues?.clientId) {
      if (init) {
        handleAutoBusinessInfo();
        setInit(false);
      }
    }
  }, [props?.createLeadValues]);

  const confirm = () => {
    props.handleFormChanged(1);
  };
  useEffect(() => {
    if (props.formValues) {
      Object.entries(props.formValues).forEach(([key, value]) => {
        if (value === null || value === undefined || value === "$") {
        } else {
          confirm();
        }
      });
    }
    if (props?.formValues?.businessName !== undefined) {
      props.sendBusinessName(props.formValues.businessName);
    }

    // props.formValues && props.formValues.forEach((formValue:any, i:number) => {
    //   if (i === 0) {
    //     if (formValue && formValue.email && formValue.emailType) {
    //       console.log(formValue);
    //       setDisableBtn(false);
    //     } else {
    //       console.log("not present");
    //       setDisableBtn(true);
    //     }
    //   }
    // });

    // for (let i = 0; i < 100; i++) {
    //   if (i === 0) {
    //     if (props.formValues && props.formValues[`email${i}`]) {
    //       if (
    //         props.formValues &&
    //         props.formValues[`email${i}`].email &&
    //         props.formValues[`email${i}`].emailType
    //       ) {
    //         console.log(props.formValues[`email${i}`]);
    //         setDisableBtn(false);
    //       } else {
    //         console.log("not present");
    //         setDisableBtn(true);
    //       }
    //     } else {
    //       console.log("no present", props.formValues);
    //       setDisableBtn(true);
    //     }
    //   }
    //   if (i > 0) {
    //     setDisableBtn(false);
    //     console.log(i);
    //     if (props.formValues && props.formValues[`email${i - 1}`]) {
    //       if (
    //         props.formValues[`email${i}`] &&
    //         props.formValues[`email${i}`].email &&
    //         props.formValues[`email${i}`].emailType
    //       ) {
    //         console.log(props.formValues[`email${i}`]);
    //         setDisableBtn(false);
    //       } else {
    //         setDisableBtn(false);
    //         console.log("not present", disableBtn);
    //       }
    //     } else {
    //       setDisableBtn(false);
    //     }
    //   }

    //   if (props.formValues && props.formValues.hasOwnProperty("phone0")) {
    //     if (
    //       props.formValues &&
    //       props.formValues.phone0.phone &&
    //       props.formValues.phone0.phoneType
    //     ) {
    //       console.log(props.formValues.phone0);
    //       setDisableBtn(false);
    //     } else {
    //       setDisableBtn(true);
    //     }
    //   } else {
    //     setDisableBtn(true);
    //   }
    // }
  }, [props?.formValues]);

  const handleEmailFields = () => {
    setEmailFields((prevSets) => prevSets + 1);
    setEmailSelectedButtons((prev) => [...prev, false]);
  };

  const handlePhoneFields = () => {
    setPhoneFields((prevSets) => prevSets + 1);
    setPhoneSelectedButtons((prev) => [...prev, false]);
  };

  const handleEmailButtonClick = (index: number) => {
    setEmailSelectedButtons((prev) =>
      prev.map((value, idx) => (idx === index ? !value : false))
    );
  };

  const handlePhoneButtonClick = (index: number) => {
    setPhoneSelectedButtons((prev) =>
      prev.map((value, idx) => (idx === index ? !value : false))
    );
  };

  const EmailCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const error =
      value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? false
        : true;
    setEmailCheck(error);
  };

  const streetAddress = async (
    event: React.ChangeEvent<HTMLInputElement>,
    addressType: string
  ) => {
    if (addressType === "business") {
      setDisableBusinessAddress(false);
      props.change("businessZipCode", "");
      props.change("businessCity", "");
      props.change("businessState", "");
    }
    if (addressType === "contact") {
      setDisableContactAddress(false);
      props.change("contactZipCode", "");
      props.change("contactCity", "");
      props.change("contactState", "");
    }
    if (event.target.value !== "") {
      await service
        .getAddressSuggestions(event.target.value)
        .then((response: AxiosResponse<suggestions>) => {
          if (addressType === "contact") {
            if (
              response.data.suggestions.length != 0 &&
              event.target.value != ""
            ) {
              setContactSuggestions(response.data);
              setContactSuggestionsBox(true);
            } else {
              setContactSuggestions([]);
              setContactSuggestionsBox(false);
            }
          }

          if (addressType === "business") {
            if (
              response.data.suggestions.length != 0 &&
              event.target.value != ""
            ) {
              setBusinessSuggestions(response.data);
              setBusinessSuggestionsBox(true);
            } else {
              setBusinessSuggestions([]);
              setBusinessSuggestionsBox(false);
            }
          }
        })
        .catch((error: AxiosError) => {
          // toast.error("Something Went Wrong");
          catchErrorGeneric("Something went wrong");
        });
    } else {
      if (addressType === "contact") {
        setContactSuggestions(null);
        setContactSuggestionsBox(false);
      }
      if (addressType === "business") {
        setBusinessSuggestions(null);
        setBusinessSuggestionsBox(false);
      }
    }
  };

  const selectedValue = (indexValue: any, addressType: string) => {
    const suggestionValue =
      contactSuggestionsData?.suggestions[indexValue] ||
      businessSuggestionsData?.suggestions[indexValue];
    if (addressType === "business") {
      props.change("businessStreetAddress", suggestionValue?.street_line);
      props.change("businessCity", suggestionValue?.city);
      props.change("businessZipCode", suggestionValue?.zipcode);
    }
    if (addressType === "contact") {
      props.change("contactStreetAddress", suggestionValue?.street_line);
      props.change("contactCity", suggestionValue?.city);
      props.change("contactZipCode", suggestionValue?.zipcode);
    }
    const stateId = props?.statesData?.find(
      (m: any) => m.text == suggestionValue?.state
    )?.value;

    if (addressType === "business") {
      props.change("businessState", stateId);
      setBusinessSuggestionsBox(false);
      setDisableBusinessAddress(true);
    }

    if (addressType === "contact") {
      props.change("contactState", stateId);
      setContactSuggestionsBox(false);
      setDisableContactAddress(true);
    }
  };

  const onStreetAddressBlur = (addressType: string) => {
    setTimeout(() => {
      if (addressType === "contact") {
        setContactSuggestionsBox(false);
        setContactSuggestions(null);
      }
      if (addressType === "business") {
        setBusinessSuggestionsBox(false);
        setBusinessSuggestions(null);
      }
    }, 500);
  };

  const renderEmailFields = (index: number) => {
    const fieldName = `email${index}`;
    const isPrimary = selectedEmailButtons[index];
    const formValues = props.formValues;

    if (formValues && formValues[fieldName]) {
      const value = isPrimary;
      props.dispatch(change("CreateLeadForm", `${fieldName}.isPrimary`, value));
    }

    //  Reset 'isPrimary false' for other email fields
    selectedEmailButtons.forEach((button, i) => {
      if (i !== index) {
        const resetFieldName = `email${i}.isPrimary`;
        if (formValues && formValues[resetFieldName]) {
          props.dispatch(
            change("CreateLeadForm", resetFieldName, selectedEmailButtons[i])
          );
        }
      }
    });
    if (selectedEmailButtons.length > 1 && formValues === undefined) {
      const modifiedEmailSelectedButtons = selectedEmailButtons.map(
        (value, index) => {
          return index === 0 ? false : value;
        }
      );
      if (
        JSON.stringify(modifiedEmailSelectedButtons) !==
        JSON.stringify(selectedEmailButtons)
      ) {
        setEmailSelectedButtons(modifiedEmailSelectedButtons);
      }
    }
    return (
      <>
        <Col md="7">
          <Field
            name={`${fieldName}.email`}
            component={TextField}
            type="text"
            label="Email"
            helpText="Email"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => EmailCheck(e)}
          />
        </Col>
        <Col md="4">
          <Field
            name={`${fieldName}.emailType`}
            component={SelectField}
            type="text"
            label="Email Type"
            values={props.emailTypesData}
            helpText="emailType"
          // disabled={disableAddress}
          />
        </Col>
        {emailFields > 1 && (
          <Col md="2">
            <Field
              name={`${fieldName}.isPrimary`}
              label="Primary"
              component={EmailCheckButton}
              selectedEmailButton={selectedEmailButtons[index]}
              value={selectedEmailButtons[index]}
              handleEmailButtonClick={() => handleEmailButtonClick(index)}
            />
          </Col>
        )}
      </>
    );
  };

  const renderPhoneFields = (index: number) => {
    const fieldName = `phone${index}`;
    const isPrimary = selectedPhoneButtons[index];
    const formValues = props.formValues;
    // set isPrimary true for selected field
    if (formValues && formValues[fieldName]) {
      const value = isPrimary;
      props.dispatch(change("CreateLeadForm", `${fieldName}.isPrimary`, value));
    }

    //  Reset 'isPrimary false' for other phone fields
    selectedPhoneButtons.forEach((button, i) => {
      if (i !== index) {
        const resetFieldName = `phone${i}.isPrimary`;
        if (formValues && formValues[resetFieldName]) {
          props.dispatch(
            change("CreateLeadForm", resetFieldName, selectedPhoneButtons[i])
          );
        }
      }
    });
    if (selectedPhoneButtons.length > 1 && formValues === undefined) {
      const modifiedPhoneSelectedButtons = selectedPhoneButtons.map(
        (value, index) => {
          return index === 0 ? false : value;
        }
      );
      if (
        JSON.stringify(modifiedPhoneSelectedButtons) !==
        JSON.stringify(selectedPhoneButtons)
      ) {
        setPhoneSelectedButtons(modifiedPhoneSelectedButtons);
      }
    }
    return (
      <>
        <Col md="6" className="phoneFiled" style={{ paddingRight: "0" }}>
          <Field
            name={`${fieldName}.phone`}
            component={PhoneNumberField}
            type="text"
            label="Phone"
            helpText="PhoneNumber"
          />
        </Col>
        <Col md="2" className="phExt">
          <Field
            name={`${fieldName}.phExt`}
            component={TextField}
            type="text"
            label="Ext."
            helpText="Ext"
            normalize={NormaliseExt}
          />
        </Col>
        <Col md="3" className="phoneType">
          <Field
            name={`${fieldName}.phoneType`}
            component={SelectField}
            type="text"
            label="Phone Type"
            values={props.phoneTypesData}
            helpText="phoneType"
          />
        </Col>
        {phoneFields > 1 && (
          <Col md="2">
            <Field
              name={`${fieldName}.isPrimary`}
              label="Primary"
              component={PhoneCheckButton}
              selectedPhoneButton={selectedPhoneButtons[index]}
              value={selectedPhoneButtons[index]}
              handlePhoneButtonClick={() => handlePhoneButtonClick(index)}
            />
          </Col>
        )}
      </>
    );
  };

  const getProductId = (name: string) => {
    const product = props.productsData.filter(
      (each: options) => each.value === name
    );
    return product[0]?.id;
  };

  const saveProfilephoto = async (clientId: string) => {
    if (props?.formValues?.photo) {
      const data = {
        section: "profileLogo",
        clientId: clientId,
        module: "profile",
      };
      setLoader(true);
      const file = [props?.formValues?.photo];

      await service
        .filesSaveAttachment(file, data)
        .then((response: any) => {
          setLoader(false);
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
          // toast.error("Something Went Wrong");
          catchErrorGeneric("Something went wrong");
          setLoader(false);
        });
    }
  };

  const createLead = async () => {
    const postLead = {
      screen: "ProspectTR",
      sections: "createProspectt",
      workflowRelated: true,
      orgId: context.bankuserDetails?.organization.orgId,
      data: {
        orgId: context.bankuserDetails?.organization.orgId,
        firstName: props?.formValues?.firstName || null,
        lastName: props?.formValues?.lastName || null,
        title: props?.formValues?.title || null,
        dob: transformDateWithoutTime(props?.formValues?.dob),
        clientsStatus: "active",
        contactStatus: "active",
        clientProductStatus: "In Progress",
        clientProductId: props?.createLeadValues?.clientProductId,
        isPrimary: "true",
        streetAddress: props?.formValues?.contactStreetAddress || null,
        unitSuite: props?.formValues?.contactUnitSuite || null,
        city: props?.formValues?.contactCity || null,
        state: props?.formValues?.contactState || null,
        zipCode: props?.formValues?.contactZipCode || null,
        email: props?.formValues?.email || null,
        emailType: props?.formValues?.emailType || null,
        phoneNumber: sendPhondNumberFormat(props?.formValues?.phoneNumber) || null,
        phoneExt: props?.formValues?.phExt || null,
        phoneType: props?.formValues?.phoneType || null,
        businessName: props?.formValues?.businessName || null,
        internalNotes: props?.formValues?.internalNotes || null,
        account: props?.formValues?.account || null,
        productId: getProductId(props?.formValues?.productName) || null,
        estimatedValue: props?.formValues?.estimatedValue || null,
        assignTo: props?.createLeadValues?.assignTo || context.bankuserDetails?.userId || null, //login useruuid
        expectedCloseDate:
          transformDateWithDash(props?.formValues?.expectedClose) || null,
        percentageToSale: props?.formValues?.percentToSale || null,
        businessStreetAddress: props?.formValues?.businessStreetAddress || null,
        businessUnitSuite: props?.formValues?.businessUnitSuite || null,
        businessCity: props?.formValues?.businessCity || null,
        businessState: props?.formValues?.businessState || null,
        businessZipcode: props?.formValues?.businessZipCode || null,
        clientContactId: props?.createLeadValues?.clientContactId,
        parentClientId: !props?.isExistingCreateLead
          ? props?.parentClientId
            ? props?.parentClientId
            : clientId
          : clientId,
        clientProductsContactMappingId: props?.createLeadValues?.clientProductsContactMappingId || props?.clientProductsContactMappingId,
      },
    };

    const editLead = {
      ...postLead,
      workflowRelated: true,
      data: {
        ...postLead.data,
        parentClientId: getId(),
        clientProductStatus: props?.createLeadValues?.clientProductStatus,
        clientId:
          !props?.isExistingCreateLead ||
            props?.isExistingCreateLead ||
            props?.firstBtn
            ? props?.createLeadValues?.clientId
            : clientId,
        clientBusinessInfoId: props?.createLeadValues?.clientBusinessInfoId,
        clientProductId:
          props?.createLeadValues?.clientProductId ||
          props?.createLeadValues?.clientProductsId,
        updatedDate: new Date(),
        createdDate: transformDateWithDash(
          props?.createLeadValues?.createdDate
        ),
        createdBy: props?.createLeadValues?.createdBy,
        profileDocId:
          props?.formvalues?.photo && props?.createLeadValues?.profileDocId,
      },
    };
    service
      .createLead(props.buttonName === "Create Lead" ? postLead : editLead)
      .then(async (response: any) => {
        toast.success(
          props.buttonName === "Create Lead"
            ? "Lead Created Successfully..!!"
            : "Lead Edited Successfully..!!"
        );

        Trigger?.setValue(true);

        const data = {
          ...props?.formValues,
          parentClientId: props?.editLeadBtn
            ? props?.createLeadValues?.parentClientId &&
            props?.createLeadValues?.parentClientId
            : undefined,
          clientProductStatus: props?.createLeadValues?.clientProductStatus,
          clientId:
            !props?.isExistingCreateLead ||
              props?.isExistingCreateLead ||
              props?.firstBtn ||
              props?.fromTracker
              ? props?.createLeadValues?.clientId || response.data.clientId
              : clientId,
          clientBusinessInfoId:
            response.data.clientBusinessInfo?.clientBusinessInfoId,
          clientContactId: response.data.clientContact[0]?.clientContactId,
          clientProductId: response.data.clientProducts[0]?.clientProductId,
          clientProductsContactMappingId: response.data.clientProducts[0]?.clientProductsContactMapping?.clientProductsContactMappingId,
        };
        props.missingFieldsFunction(data);
        await saveProfilephoto(response.data.clientId);
        props.defaultActionProduct(response.data.clientProducts[0]?.productId);
        props.setClientId(response.data.clientId);
        props.clientProductId(response.data.clientProducts[0]?.clientProductId);
        props.defaultActionContact(
          response.data.clientContact[0]?.clientContactId
        );
        props?.getLeadData && props?.getLeadData(); // to refresh in detials page
        props?.getProducts && props?.getProducts();
        props?.handleEditLead && props?.handleEditLead();
        props?.getCompanyLogo && props?.getCompanyLogo();
        props?.buttonName === "Save" &&
          props?.handleClearValues &&
          props?.handleClearValues();
        props.buttonName === "Create Lead" && props.confirmLeadCreate();
        props.toggleHandle();
        props?.refreshTrackers && props?.refreshTrackers(); // to refresh trackers
      })
      .catch((error: any) => {
        toast.error(`${error.response.data.errorMessage}`);
      });
  };
  return (
    <>
      {loader ? (
        <SpinnerModel value={""} color={"primary"} size={""} type={"border"} />
      ) : (
        ""
      )}
      <form autoComplete="off" onSubmit={props.handleSubmit(createLead)}>
        <Container fluid>
          <Row className="LeadBtn">
            <div className="LeadBtnCardTop">
              <Button type="submit" disabled={sameLocationDisable}>
                {" "}
                {props.buttonName}
              </Button>
            </div>
          </Row>
          <Row className="createLeadCard-wrapper">
            <Col className="createLeadCard" md="2">
              <Card>
                <CardTitle tag="h5"> Create New Lead</CardTitle>
                <CardBody>
                  <div className="w-100">
                    <div className="contactInfoRow">
                      <Row>
                        <Col md="12" className="pt-4">
                          <div className="upload-container">

                            <Field
                              name="photo"
                              component={PhotoUploader}
                              initialValues={
                                props?.createLeadValues?.photo ||
                                props?.companyLogo
                              }
                              docId={props?.createLeadValues?.profileDocId}
                              deletePhoto={handleDeletePhoto}
                              type="text"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row className="inviteSendWrap">
                        <Col md="12">
                          <Row className="bottom-text">
                            <span>Created </span>
                            <label>
                              {transformDateWithoutTime(
                                props?.createLeadValues?.createdDate
                              ) || " - - -"}{" "}
                            </label>
                          </Row>
                        </Col>
                        <Col md="12">
                          <Row className="bottom-text">
                            <span>Last Updated</span>
                            <label>
                              {transformDateWithoutTime(
                                props?.createLeadValues?.updatedDate
                              ) || "- - -"}
                            </label>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md="10" className="second-container">
              <Col md={5} className="contactCard w-4">
                <Card>
                  <CardTitle tag="h5" className="contact-top">
                    Contact Info
                    <button
                      type="button"
                      className="add-button"
                      disabled={
                        props?.formValues?.businessName === undefined ||
                        props?.formValues?.businessName === null ||
                        props?.formValues?.businessName === "" ||
                        props.leadData.length <= 0
                      }
                      onClick={() => props.handleSelectExistingContact()}
                    >
                      select existing contact
                    </button>
                  </CardTitle>
                  <CardBody>
                    <div className="w-100">
                      <div className="contactInfoRow">
                        <Row>
                          <Col md="6" style={{ paddingRight: "8px" }}>
                            <Field
                              name="firstName"
                              component={TextField}
                              type="text"
                              label="First Name"
                              helpText="Firstname"
                            />
                          </Col>
                          <Col md="6">
                            <Field
                              name="lastName"
                              component={TextField}
                              type="text"
                              label="Last Name"
                              helpText="Lastname"
                            />
                          </Col>

                          <Col md="6" style={{ paddingRight: "8px" }}>
                            <Field
                              name="title"
                              component={TextField}
                              type="text"
                              label="Title"
                              helpText="title"
                            />
                          </Col>
                          <Col md="6" className="dobField">
                            <label>DOB</label>
                            <Field
                              name="dob"
                              component={PastDatePicker}
                              maxDate={new Date()}
                            />
                          </Col>
                        </Row>
                        <Row className="">
                          <Col md="8" style={{ paddingRight: "1px" }}>
                            <Field
                              name="contactStreetAddress"
                              component={TextField}
                              type="text"
                              label="Street Address"
                              helpText="Street Address"
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                              ) => streetAddress(event, "contact")}
                              onBlur={() => onStreetAddressBlur("contact")}
                              autoComplete="nope"
                            />
                            {contactSuggestionsBox &&
                              contactSuggestionsData !== null ? (
                              <div className="suggestionsbox">
                                {contactSuggestionsData?.suggestions?.map(
                                  (m: Suggestion, index: number) => (
                                    <>
                                      <p
                                        className="suggestionsContent"
                                        onClick={() =>
                                          selectedValue(index, "contact")
                                        }
                                      >
                                        {m.street_line},{m.city},{m.state},
                                        {m.zipcode}
                                      </p>
                                    </>
                                  )
                                )}
                              </div>
                            ) : (
                              ""
                            )}
                          </Col>
                          <Col md="4">
                            <Field
                              name="contactUnitSuite"
                              component={TextField}
                              type="text"
                              label="Unit, Suite. etc."
                              helpText="Street Address"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col md="6">
                            <Field
                              name="contactCity"
                              component={TextField}
                              type="text"
                              label="City"
                              helpText="City"
                              disabled={disableContactAddress}
                            />
                          </Col>
                          <Col md="3">
                            <Field
                              name="contactState"
                              component={SelectField}
                              type="text"
                              label="State"
                              values={props.statesData}
                              helpText="State"
                              disabled={disableContactAddress}
                            />
                          </Col>
                          <Col md="3">
                            <Field
                              name="contactZipCode"
                              component={TextField}
                              label="Zip Code"
                              helpText="Zipcode"
                              normalize={normaliseZipcode}
                              disabled={disableContactAddress}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <div className="fields-height">
                            {/* {Array.from({ length: emailFields }).map(
                              (_, index) => (
                                <Row key={index}>
                                  {renderEmailFields(index)}
                                </Row>
                              )
                            )} */}
                            <Row>
                              <Col md="7" className="emailField">
                                <Field
                                  name="email"
                                  component={EmailTextField}
                                  type="text"
                                  label="Email"
                                  helpText="Email"
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => EmailCheck(e)}
                                />
                              </Col>
                              <Col md="4">
                                <Field
                                  name="emailType"
                                  component={ValidateSelectField}
                                  type="text"
                                  label="Email Type"
                                  values={props.emailTypesData}
                                  helpText="emailType"
                                // disabled={disableAddress}
                                />
                              </Col>
                            </Row>
                          </div>
                          <Col md="12" className="text-container">
                            <button
                              type="button"
                              onClick={handleEmailFields}
                              className="add-button"
                              disabled={true}
                              hidden
                            >
                              Add Email
                            </button>
                          </Col>
                        </Row>
                        <Row>
                          <div className="fields-height">
                            {/* {Array.from({ length: phoneFields }).map(
                              (_, index) => (
                                <Row key={index}>
                                  {renderPhoneFields(index)}
                                </Row>
                              )
                            )} */}
                            <Row>
                              <Col
                                md="6"
                                className="phoneFiled"
                                style={{ paddingRight: "0" }}
                              >
                                <Field
                                  name="phoneNumber"
                                  component={PhoneNumberField}
                                  type="text"
                                  label="Phone"
                                  helpText="PhoneNumber"
                                />
                              </Col>
                              <Col md="2" className="phExt">
                                <Field
                                  name="phExt"
                                  component={TextField}
                                  type="text"
                                  label="Ext."
                                  helpText="Ext"
                                  normalize={NormaliseExt}
                                />
                              </Col>
                              <Col md="3" className="phoneType">
                                <Field
                                  name="phoneType"
                                  component={ValidateSelectField}
                                  type="text"
                                  label="Phone Type"
                                  values={props.phoneTypesData}
                                  helpText="phoneType"
                                />
                              </Col>
                            </Row>
                          </div>
                          <Col md="12" className="text-container">
                            <button
                              type="button"
                              onClick={handlePhoneFields}
                              className="add-button"
                              disabled={true}
                              hidden
                            >
                              Add phone
                            </button>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col md={5} className="companyCard w-4">
                <Card className="business-info-card">
                  <CardTitle tag="h5">Business Information</CardTitle>
                  <CardBody>
                    <div className="w-100">
                      <div className="contactInfoRow BizInfoRow">
                        <div className="companyInfoRow">
                          <Row className="firstRow mb-0">
                            <Col md="12" className="biz-Name-leadForm">
                              {
                                <Field
                                  name="businessName"
                                  component={TextField}
                                  type="text"
                                  label="Business Name"
                                  helpText="Business Name"
                                  value={props?.businessName}
                                  isRequired
                                  disabled={
                                    props.fromDetailsPage || businessInfoDisable
                                  }
                                  normalize={NormalizeSpace}
                                  textBlur={handleAutoBusinessInfo}
                                />
                              }
                            </Col>

                            <Col
                              md="8"
                              className="businessStreetAddress"
                              style={{ paddingRight: "0px" }}
                            >
                              <Field
                                name="businessStreetAddress"
                                component={TextField}
                                type="text"
                                label="Street Address"
                                helpText="Street Address"
                                onChange={(
                                  event: React.ChangeEvent<HTMLInputElement>
                                ) => streetAddress(event, "business")}
                                onBlur={() => onStreetAddressBlur("business")}
                                autoComplete="nope"
                                disabled={
                                  props.fromDetailsPage || businessInfoDisable
                                }
                              />
                              {businessSuggestionsBox &&
                                businessSuggestionsData !== null ? (
                                <div className="suggestionsbox">
                                  {businessSuggestionsData?.suggestions?.map(
                                    (m: Suggestion, index: number) => (
                                      <>
                                        <p
                                          className="suggestionsContent"
                                          onClick={() =>
                                            selectedValue(index, "business")
                                          }
                                        >
                                          {m.street_line},{m.city},{m.state},
                                          {m.zipcode}
                                        </p>
                                      </>
                                    )
                                  )}
                                </div>
                              ) : (
                                ""
                              )}
                            </Col>
                            <Col md="4" className="businessUnitSuite">
                              <Field
                                name="businessUnitSuite"
                                component={TextField}
                                type="text"
                                label="Unit, Suite. etc."
                                helpText="Street Address"
                                disabled={
                                  props.fromDetailsPage || businessInfoDisable
                                }
                              />
                            </Col>

                            <Col md="6">
                              <Field
                                name="businessCity"
                                component={TextField}
                                type="text"
                                label="City"
                                helpText="City"
                                disabled={
                                  props.fromDetailsPage ||
                                  disableBusinessAddress ||
                                  businessInfoDisable
                                }
                              />
                            </Col>
                            <Col md="3">
                              <Field
                                name="businessState"
                                component={SelectField}
                                type="text"
                                label="State"
                                values={props.statesData}
                                helpText="State"
                                disabled={
                                  props.fromDetailsPage ||
                                  disableBusinessAddress ||
                                  businessInfoDisable
                                }
                              />
                            </Col>
                            <Col md="3">
                              <Field
                                name="businessZipCode"
                                component={TextField}
                                label="Zip Code"
                                helpText="Zipcode"
                                normalize={normaliseZipcode}
                                disabled={
                                  props.fromDetailsPage ||
                                  disableBusinessAddress ||
                                  businessInfoDisable
                                }
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>

                <Card className="internal-notes-card">
                  <CardBody>
                    <Row>
                      <Col md="12" className="referralWrap">
                        <Field
                          name="internalNotes"
                          component={TextField}
                          type="textarea"
                          label="Internal Notes"
                          maxlength={100}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>

              <Col md={2} className="generalCard w-3">
                <Card>
                  <CardTitle tag="h5">Product Information</CardTitle>
                  <CardBody>
                    <div className="w-100">
                      <div className="contactInfoRow BizInfoRow">
                        <div className="companyInfoRow">
                          <Col md={10} className="product-name">
                            <Field
                              name="productName"
                              component={SelectField}
                              type="text"
                              label="Product Name"
                              values={props.productsData}
                            />
                          </Col>
                          <Col md="10" className="account">
                            <Field
                              name="account"
                              component={TextField}
                              type="text"
                              label="Account"
                              helpText="account"
                              disabled={
                                props?.isExistingCreateLead ||
                                props?.formValues?.productName?.length <= 0
                              }
                            />
                          </Col>
                          <Col md="10" className="noLocations">
                            <Field
                              name="estimatedValue"
                              component={TextField}
                              type="text"
                              minlength={0}
                              label="Estimated Value"
                              normalize={normaliseDollar}
                            />
                          </Col>
                          <Col
                            md="7"
                            className="expectedClose"
                            style={{ position: "relative" }}
                          >
                            <label>Expected Close</label>
                            <Field
                              name="expectedClose"
                              component={FutureDatePicker}
                              minDate={new Date()}
                              isValidation={true}
                            />
                          </Col>
                          <Col md="12">
                            <Field
                              name="percentToSale"
                              component={SelectButtonField2}
                              type="text"
                              label="Percent to Sale"
                              values={percentages}
                            />
                          </Col>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Col>
          </Row>
        </Container>
      </form>
    </>
  );
};

const mapStateToProps = (state: any, props: any) => {
  return {
    initialValues: {
      firstName: props?.createLeadValues?.firstName,
      lastName: props?.createLeadValues?.lastName,
      businessName:
        props?.autoBusinessInfo?.businessName ||
        props?.createLeadValues?.businessName ||
        props?.businessData?.businessName,
      // productName: props?.fromDetailsPage
      //   ? ""
      //   : props?.createLeadValues?.productName,
      productName: props?.createLeadValues?.productName, //
      title: props?.createLeadValues?.title,
      dob: props?.createLeadValues?.dob,
      email:
        props?.createLeadValues?.contactEmail ||
        props?.createLeadValues?.email ||
        null,
      emailType:
        props?.createLeadValues?.contactEmailType ||
        props?.createLeadValues?.emailType ||
        null,
      phoneNumber:
        props?.createLeadValues?.contactPhone ||
        props?.createLeadValues?.phoneNumber || null,
      phExt:
        props?.createLeadValues?.phoneExt ||
        props?.createLeadValues?.phExt ||
        null,
      phoneType:
        props?.createLeadValues?.contactPhoneType ||
        props?.createLeadValues?.phoneType ||
        null,
      // emailVal: props?.createLeadValues?.email0?.email,
      businessStreetAddress:
        props?.autoBusinessInfo?.businessStreetAddress ||
        props?.createLeadValues?.businessStreetAddress ||
        props?.businessData?.businessStreetAddress,
      businessUnitSuite:
        props?.autoBusinessInfo?.businessUnitSuite ||
        props?.createLeadValues?.businessUnitSuite ||
        props?.businessData?.businessUnitSuite,
      businessZipCode:
        props?.autoBusinessInfo?.businessZipCode ||
        props?.createLeadValues?.businessZipCode ||
        props?.businessData?.businessZipCode,
      account: props?.fromDetailsPage
        ? props.isExistingCreateLead
          ? props?.productInfo?.account
          : props?.createLeadValues?.account
        : props?.createLeadValues?.account,
      // account: props?.createLeadValues?.account,
      contactStreetAddress: props?.createLeadValues?.contactStreetAddress,
      contactUnitSuite: props?.createLeadValues?.contactUnitSuite,
      businessCity:
        props?.autoBusinessInfo?.businessCity ||
        props?.createLeadValues?.businessCity ||
        props?.businessData?.businessCity,
      businessState:
        props?.autoBusinessInfo?.businessState ||
        props?.createLeadValues?.businessState ||
        props?.businessData?.businessState,
      // estimatedValue: dollarSymbol(props?.createLeadValues?.estimatedValue),//
      estimatedValue: dollarSymbol(props?.createLeadValues?.estimatedValue),
      // expectedClose: props?.fromDetailsPage
      //   ? ""
      //   : transformDateWithoutTime(props.createLeadValues?.expectedCloseDate),//
      expectedClose:
        transformDateWithoutTime(props.createLeadValues?.expectedClose) ||
        transformDateWithoutTime(props.createLeadValues?.expectedCloseDate),
      contactCity: props?.createLeadValues?.contactCity,
      contactState: props?.createLeadValues?.contactState,
      contactZipCode: props?.createLeadValues?.contactZipCode,
      // percentToSale: props?.fromDetailsPage
      //   ? ""
      //   : props?.createLeadValues?.percentageToSale,//
      percentToSale:
        props?.createLeadValues?.percentToSale ||
        props?.createLeadValues?.percentageToSale,
      internalNotes: props.createLeadValues?.internalNotes,
      photo: props?.createLeadValues?.photo,
    },
    formValues: getFormValues("CreateLeadForm")(state),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "CreateLeadForm", // a unique identifier for this form
    enableReinitialize: true,
    touchOnChange: true,
    validate,
    warn,
  })(CreateLeadForm)
);
